import React from 'react'
import ReactDOM from 'react-dom'
import '../../patterns/css/process-bar.css'

class ProcessBar extends React.Component {
  componentDidMount(){
    //create an element to append
    this.modal = document.createElement('div');
    //append that shit
    document.body.appendChild(this.modal);
    //call the render method to add custom styled div and children contents to appended element
    this.renderModalContent();
  }
  componentWillReceiveProps(){
    this.renderModalContent();
  }
  componentWillUnmount(){
    //act like this shit was never here ever
    ReactDOM.unmountComponentAtNode(this.modal);
    document.body.removeChild(this.modal);
  }
  renderModalContent(){
    //put something in the appended shit
    ReactDOM.render(
      <div id='modal-container' className='active'>
        <div className='modal-backdrop fade show bg-change'></div>
        <div className='modal fade show'>
            <div className="spinner"></div>
        </div>
      </div>,
      this.modal
    );
  }
  render(){
    //don't render anything here because we are appending to the body portal style ahhhh yissssss
    return null;
  }
}

export default ProcessBar
